import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { toDateString } from 'app/shared/utils/date';
import { useSMSService } from 'hooks/messaging/sms';
import { useAudienceService } from 'hooks/users/audience';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';

export const SMSBasicInfo = ({ id }) => {
  const dispatch = useDispatch();
  const { fetchAudiences } = useAudienceService();
  const { fetchSMSs } = useSMSService();

  const [audiences, setAudiences] = useState([]);
  const [message_data, setMessageData] = useState({});

  useEffect(() => {
    dispatch(
      setPageTitle([
        { title: 'SMS', path: '/sms' },
        { title: message_data.title || '-', path: '.' }
      ])
    );
  }, [message_data]);

  useEffect(() => {
    if (!id) return;
    fetchSMSs({ query_string: `id=${id}` }).then(({ messages: [message] }) => {
      if (!message) return;
      setMessageData(message);
      if (message.type === 'campaign') {
        fetchAudiences({ query_string: `id=${message.audiences.join('')}` }).then(
          ({ audiences: auds }) => {
            setAudiences(auds);
          }
        );
      }
    });
  }, [id]);

  return (
    <>
      <BasicInfoSection title="Basic Details">
        <DetailItem title="title">{message_data.title}</DetailItem>
        <DetailItem title="code">{message_data.code}</DetailItem>
        <DetailItem title="sender ID">{message_data.sender_id}</DetailItem>
        <DetailItem title="Message">{message_data.message}</DetailItem>
        <DetailItem title="Type">{message_data.type}</DetailItem>
        <DetailItem title="Pages">{message_data.pages}</DetailItem>
        {message_data.type === 'campaign' && (
          <>
            <DetailItem title="status">{message_data.status}</DetailItem>
            <DetailItem title="Audiences">
              {audiences.map((aud) => (
                <div key={aud.id}>{aud.name}</div>
              ))}
            </DetailItem>
            <DetailItem title="schedule">{toDateString(message_data.schedule.date)}</DetailItem>
          </>
        )}
      </BasicInfoSection>
    </>
  );
};
